import AutoCompleteProduct from "react-autocomplete";
import { Button, Modal } from "react-bootstrap-v5";

export default function ShipmentDetail(props) {
  const {
    addProduct,
    onchangeHandler,
    deleteHandler,
    setGood,
    goodvalue,
    itemProduct,
    valueItem,
    getGrandTotal,
    handleCloseModal,
    productChange,
    searchingHandler,
    validator,
    productItemForArray,
    productModal,
    setProductModal,
    addSelectedProduct,
  } = props;
  let productCount = 0;

  return (
    <div className="calculation_wrapper row justify-content-center">
      <div class="tab-content">
        <div
          class="tab-pane active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <div className="border-custom col-12 p-3 w-100">
            <div className="row">
              <div className="mb-3 col-4">
                <div className="row">
                  <div className="col-1 ps-0">
                    <label className="form-label">S.No.</label>
                  </div>
                  <div className="col-5">
                    <label className="form-label">Product Detail</label>
                  </div>
                  <div className="col-6">
                    <label className="form-label">Product Description</label>
                  </div>
                </div>
              </div>

              <div className="col-1">
                <label className="form-label">Pkgs (No.)</label>
              </div>

              <div className="col-4 text-center">
                <label className="form-label">
                  Weight & Dimension per Package
                </label>
              </div>

              <div className="col-3">
                <div className="row">
                  <div className="col-5">
                    <label className="form-label">Total Volume (CBM)</label>
                  </div>
                  <div className="col-5">
                    <label className="form-label">Total Weight (KG)</label>
                  </div>
                  <div className="col-2"></div>
                </div>
              </div>
            </div>

            {productItemForArray.map((val, key) => {
              if (
                key > 0 && val.item_description &&
                productItemForArray[key - 1].item_description ===
                  val.item_description
              ) {
              } else {
                productCount += 1;
              }
              return (
                <div className="row mt-2">
                  <div className="mb-3 col-4">
                    <div className="row">
                      <div className="px-1 col-1">
                        {key > 0 && val.item_description &&
                        productItemForArray[key - 1].item_description ===
                          val.item_description ? (
                          ""
                        ) : (
                          <p>{productCount}</p>
                        )}
                      </div>

                      {key > 0 &&
                      val.type === "select" &&
                      productItemForArray[key - 1].item_description ===
                        val.item_description ? (
                        ""
                      ) : (
                        <div className="form-group px-1 col-5">
                          <select
                            className="form-control "
                            onChange={(e) => {
                              // onChangeEvent(key, e);
                              if (e.target.value === "select") {
                                setProductModal({ open: true, data: null,index:key });
                              }
                            }}
                            name="type"
                            disabled={val.type === "select"}
                            value={val.type}
                          >
                            <option value="enter">Enter manually</option>
                            <option value="select">Select from list</option>
                          </select>
                        </div>
                      )}
                      {key > 0 &&
                      val.type === "select" &&
                      productItemForArray[key - 1].item_description ===
                        val.item_description ? (
                        ""
                      ) : (
                        <div className="col-6 px-1">
                          <input
                            className="form-control"
                            placeholder="Product Description"
                            name="item_description"
                            disabled={val.type === "select"}
                            value={val.item_description}
                            onChange={(e) => onchangeHandler(key, e)}
                          />
                          {validator.current.message(
                            "Description",
                            val.item_description,
                            "required",
                            {
                              className: "text-danger text-capitalize",
                            }
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-1 ps-1 pe-1">
                    {key > 0 &&
                    val.type === "select" &&
                    productItemForArray[key - 1].item_description ===
                      val.item_description ? (
                      ""
                    ) : (
                      <>
                        <input
                          required=""
                          type="number"
                          min="0"
                          className="form-control"
                          placeholder="Pkgs"
                          onChange={(e) => onchangeHandler(key, e)}
                          name="no_of_pkgs"
                          value={val.no_of_pkgs}
                        />
                        {validator.current.message(
                          "quantity",
                          val.no_of_pkgs,
                          "required",
                          {
                            className: "text-danger text-capitalize fSize10",
                          }
                        )}
                      </>
                    )}
                  </div>

                  <div className="col-4 text-center">
                    <div className="d-flex">
                      <div className="position-relative me-2">
                        <input
                          required=""
                          type="number"
                          min="0"
                          disabled={val.type === "select"}
                          className="form-control "
                          placeholder="Kilogram"
                          onChange={(e) => onchangeHandler(key, e, "dimension")}
                          name="kilogram"
                          value={val.dimension.kilogram}
                        />
                        {validator.current.message(
                          "Kilogram",
                          val.dimension.kilogram,
                          "required",
                          {
                            className:
                              "text-danger text-capitalize customerror_msg",
                          }
                        )}
                      </div>
                      <div className="position-relative me-2">
                        <input
                          required=""
                          type="number"
                          min="0"
                          disabled={val.type === "select"}
                          className="form-control"
                          placeholder="Length"
                          onChange={(e) => onchangeHandler(key, e, "dimension")}
                          name="length"
                          value={val.dimension.length}
                        />
                        {validator.current.message(
                          "Length",
                          val.dimension.length,
                          "required",
                          {
                            className:
                              "text-danger text-capitalize customerror_msg",
                          }
                        )}
                      </div>

                      <div className="position-relative me-2">
                        <input
                          required=""
                          type="number"
                          min="0"
                          disabled={val.type === "select"}
                          className="form-control"
                          placeholder="Width"
                          onChange={(e) => onchangeHandler(key, e, "dimension")}
                          name="width"
                          value={val.dimension.width}
                        />
                        {validator.current.message(
                          "Weight",
                          val.dimension.width,
                          "required",
                          {
                            className:
                              "text-danger text-capitalize customerror_msg",
                          }
                        )}
                      </div>

                      <div className="position-relative">
                        <input
                          required=""
                          type="number"
                          min="0"
                          disabled={val.type === "select"}
                          className="form-control"
                          placeholder="Height"
                          onChange={(e) => onchangeHandler(key, e, "dimension")}
                          name="height"
                          value={val.dimension.height}
                        />
                        {validator.current.message(
                          "Height",
                          val.dimension.height,
                          "required",
                          {
                            className:
                              "text-danger text-capitalize customerror_msg",
                          }
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="row">
                      <div className="col-5">
                        {key > 0 &&
                        val.type === "select" &&
                        productItemForArray[key - 1].item_description ===
                          val.item_description ? (
                          ""
                        ) : (
                          <input
                            type="number"
                            min="0"
                            className="form-control"
                            placeholder="CBM"
                            name="total_volume_CBM"
                            value={val.total_volume_CBM}
                            disabled
                          />
                        )}
                      </div>
                      <div className="col-5">
                        {key > 0 &&
                        val.type === "select" &&
                        productItemForArray[key - 1].item_description ===
                          val.item_description ? (
                          ""
                        ) : (
                          <input
                            required=""
                            type="number"
                            min="0"
                            className="form-control"
                            placeholder="KG"
                            name="total_weight_KG"
                            value={val.total_weight_KG}
                            disabled
                          />
                        )}
                      </div>
                      <div className="col-2">
                        {key > 0 &&
                        val.type === "select" &&
                        productItemForArray[key - 1].item_description ===
                          val.item_description ? (
                          ""
                        ) : (
                          <button
                            type="button"
                            className="btn-close removePosition"
                            onClick={() => deleteHandler(key, val)}
                          ></button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="border-custom px-3 py-2 w-100">
            <div className="row">
              <div className="col-4">
                <p className="form-label text-center fw-bold w-100">Total</p>
              </div>

              <div className="col-1">
                <p className="form-label text-center fw-bold">
                  {getGrandTotal(productItemForArray)?.number_of_packages}
                  {/* {grandTotal.number_of_packages} */}
                </p>
              </div>

              <div className="col-4"></div>

              <div className="col-3 row">
                <div className="col-5">
                  <p className="form-label text-center fw-bold">
                    {getGrandTotal(productItemForArray)?.volume}
                    {/* {grandTotal.volume} */}
                  </p>
                </div>

                <div className="col-5">
                  <p className="form-label text-center fw-bold w-100">
                    {getGrandTotal(productItemForArray)?.weight}
                    {/* {grandTotal.weight} */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-3">
              <label className="form-label">Total Shipment Value</label>
              <input
                required=""
                type="number"
                min="0"
                className="form-control"
                placeholder="Shipment Value"
                name="items_goods"
                onChange={(e) => setGood(e.target.value)}
                value={goodvalue}
              />
              {validator.current.message(
                "Shipment Value",
                goodvalue,
                "required",
                { className: "text-danger text-capitalize" }
              )}
            </div>

            <div class="col-6 text-end">
              <button
                class="btn btn-success mt-3"
                type="button"
                onClick={() => addProduct()}
              >
                Add Product
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={productModal.open}
        onHide={() => handleCloseModal()}
        animation={false}
        centered
      >
        <Modal.Body className="p-5">
          <h5 className="form-label fw-bold my-2">
            Select Product Information
          </h5>
          {itemProduct && (
            <div className="autocomplete-wrapper">
              <AutoCompleteProduct
                getItemValue={(item) => item.label}
                items={itemProduct}
                renderMenu={(item) => <div className="dropdown">{item}</div>}
                renderItem={(item, isHighlighted) => (
                  <div
                    className={`item ${isHighlighted ? "selected-item" : ""}`}
                  >
                    {item.label}
                  </div>
                )}
                inputProps={{ placeholder: "Enter Product", autoFocus: true }}
                value={valueItem}
                onChange={(e) => searchingHandler(e)}
                onSelect={(val) => productChange(val)}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center mt-3">
          <Button
            variant="success"
            className="px-5"
            onClick={() => handleCloseModal()}
          >
            Back
          </Button>
          <Button
            variant="success"
            className="px-5"
            onClick={() => addSelectedProduct()}
          >
            ADD
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
